import React from 'react';
import { useOutletContext } from 'react-router-dom';
import type { LearnMoreOutletContext, LearnMoreSection } from '../LearnMore';

interface UseLearnMoreSectionsOptions {
  pageTitle?: string;
}

const useLearnMoreSections = (
  sections: LearnMoreSection[],
  options?: UseLearnMoreSectionsOptions,
): void => {
  const context = useOutletContext<LearnMoreOutletContext | null>();
  const pageTitle = options?.pageTitle;

  React.useEffect(() => {
    if (!context) {
      return;
    }

    context.registerSections(sections);
    context.setPageMeta(pageTitle ? { breadcrumbLabel: pageTitle } : undefined);

    return () => {
      context.clearSections();
      context.setPageMeta(undefined);
    };
  }, [context, sections, pageTitle]);
};

export default useLearnMoreSections;
